import { useState, useRef, useEffect } from "react";

import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";

import MenuList from "@mui/material/MenuList";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";

import { MoreHoriz } from "@mui/icons-material";

/**
 *
 * @param {Object} options { label: string, onClick: Function, startIcon: JSX.Element, disabled: boolean }[]
 * @param {Function} renderButton
 * @returns
 */
const Dropdown = ({
  options,
  optionsPlacement = "bottom-end",
  renderButton,
  scrollPosition,
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleSelect = (e, onClick) => {
    typeof onClick === "function" && onClick();
    handleClose(e);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  useEffect(() => {
    if (open) {
      setOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollPosition]);

  return (
    <div>
      {typeof renderButton === "function" ? (
        renderButton({ onClick: handleToggle, ref: anchorRef })
      ) : (
        <IconButton ref={anchorRef} onClick={handleToggle}>
          <MoreHoriz />
        </IconButton>
      )}
      {/* <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {options.map(({ label, onClick, startIcon }, index) => (
          <MenuItem key={index} onClick={() => handleSelect(onClick)}>
            {startIcon && (
              <Box
                sx={{
                  marginRight: 1,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {startIcon}
              </Box>
            )}
            {label}
          </MenuItem>
        ))}
      </Menu> */}
      <Popper
        sx={{ zIndex: 2 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement={optionsPlacement}
        transition
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-end" ? "left top" : "left bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={handleListKeyDown}
                >
                  {options.map(({ label, onClick, startIcon, disabled }, index) => (
                    <MenuItem
                      key={index}
                      onClick={(e) => handleSelect(e, onClick)}
                      sx={{
                        minWidth: 150,
                      }}
                      disabled={disabled || false}
                    >
                      {startIcon && (
                        <Box
                          sx={{
                            marginRight: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {startIcon}
                        </Box>
                      )}
                      {label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

export default Dropdown;
